/**
 * Resolves the tab that a keyboard interaction on a tab list should activate,
 * following the WAI-ARIA tabs pattern with horizontal orientation and wrapping.
 * Returns `undefined` for keys that do not navigate so callers can let the
 * browser handle them.
 */
export function navigateTabs<Id extends string>(
    key: string,
    tabIds: readonly Id[],
    activeTab: Id
): Id | undefined {
    const count = tabIds.length;
    const currentIndex = tabIds.indexOf(activeTab);
    if (count === 0 || currentIndex === -1) return undefined;
    switch (key) {
        case 'ArrowLeft':
            return tabIds[(currentIndex - 1 + count) % count];
        case 'ArrowRight':
            return tabIds[(currentIndex + 1) % count];
        case 'Home':
            return tabIds[0];
        case 'End':
            return tabIds[count - 1];
        default:
            return undefined;
    }
}
